import {subYears} from "date-fns";

export const getMaxDate = () => {
  const now = new Date();
  return subYears(now, 14);
}

export const getMinDate = () => {
  const now = new Date();
  return subYears(now, 100);
}

export const formatSimpleDate = (date: Date) => {
  return date ? date.toISOString().split('T')[0].replace(",", ".") : null;
}